import { useLoggedOutSuppliersLayoutElements } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/LoggedOutSuppliersLayoutElement/useLoggedOutSuppliersLayoutElements";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { ILayoutElement } from "@faire/web-api--source/indigofair/data/ILayoutElement";

export const useHeaderCarouselCategoriesToDisplay = () => {
  const layoutElements = useLoggedOutSuppliersLayoutElements();

  const headerCarousel =
    layoutElements?.find(
      (layoutElement) =>
        layoutElement.type === ILayoutElement.Type.AVATAR_CAROUSEL_WITH_GRID
    )?.layout_element_data ?? [];
  return headerCarousel
    .map((layoutElementData) => layoutElementData.category_tile)
    .filter(isNotUndefined);
};
